import React from "react";
import { Box, Grid } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { CardGenerico } from "../../Dashboard/components/CardQuick";

export default function Infos() {
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <CardGenerico
            color="success"
            url="/avaliacaoEmpresa/informacoes/TOTAL_AVALIACOES"
            icon={<CheckOutlinedIcon />}
            maskTypeValue="int"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <CardGenerico
            color="yellow"
            url="/avaliacaoEmpresa/informacoes/MEDIA"
            icon={<StarIcon />}
            maskTypeValue="double"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
